import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { restoreSessionHandoff } from '../utils/session-handoff.util';

/**
 * Restores a one-time NextGen session handoff into sessionStorage before
 * AuthorizationGuard runs on the top-level /confighub route.
 */
@Injectable({ providedIn: 'root' })
export class ConfigHubSessionHandoffGuard implements CanActivate {
  private readonly router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean | UrlTree {
    const handoffId = route.queryParamMap.get('handoff');
    if (!handoffId) {
      return true;
    }

    restoreSessionHandoff(handoffId);
    return this.router.createUrlTree(['/confighub'], { queryParams: {} });
  }
}
